import { Vendor } from "@shared/index";

export type SFDCAuthContextState = [state: SFDCAuthState, dispatch: SFDCAuthDispatch, utils?: UseAuthContextUtils];

export type UseAuthUtils = {
  tokenExpired: () => void;
};
// Keys used for writing to local storage
export const sfdcLocalStorageKeys = {
  sfdcAuthToken: "@sfdc_auth_token",
  sfdcIdToken: "@sfdc_id_token",
  sfdcRefreshToken: "@sfdc_refresh_token",
};

// Updated return type to boolean to indicate success/failure
export type FetchTokensOnAuth = (code: string, handleSetVendorAndInitialize: HandleSetVendor) => Promise<void>;

export type HandleSetVendor = (vendor: Vendor | undefined) => void;

export type HandleSetVendorInitialized = (initialized: boolean) => void;

export type UseAuthContextUtils = {
  fetchTokensOnAuth: FetchTokensOnAuth;
  clearAuthProvider: () => void;
};

export interface SFDCAuthState {
  initialized: boolean;
  loading: boolean;
  sfdcAuthToken: string | undefined | null;
  sfdcIdToken: string | undefined | null;
  redirectUrl?: string | null;
  sfdcRefreshToken?: string | null;
}

export type SetInitializedAction = {
  type: "SET_INITIALIZED";
};

export type SetSFDCAuthLoadingAction = {
  type: "SET_SFDC_AUTH_LOADING";
  payload: boolean;
};

export type SetSFDCAuthTokensAction = {
  type: "SET_SFDC_AUTH_TOKENS";
  payload: {
    sfdcAuthToken: SFDCAuthState["sfdcAuthToken"];
    sfdcIdToken: SFDCAuthState["sfdcIdToken"];
    sfdcRefreshToken: SFDCAuthState["sfdcRefreshToken"];
  };
};

export type SetRedirectUrlAction = {
  type: "SET_REDIRECT_URL";
  payload: string;
};

export type ClearRedirectUrlAction = {
  type: "CLEAR_REDIRECT_URL";
};

export type SFDCAuthActions =
  | SetInitializedAction
  | SetSFDCAuthLoadingAction
  | SetSFDCAuthTokensAction
  | SetRedirectUrlAction
  | ClearRedirectUrlAction;

export type SFDCAuthDispatch = React.Dispatch<SFDCAuthActions>;
